import React, { useEffect } from 'react';
import { LanguageProvider } from '../context/LanguageContext';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { BlueprintHero } from '../components/blueprint/BlueprintHero';
import { BlueprintNav } from '../components/blueprint/BlueprintNav';
import { OverviewSection, GuestJourneySection, FivePortalsSection, StoryArcSection, FloorMapSection, FinalRevealSection } from '../components/blueprint/BlueprintExperience';
import { FoodDrinkSection, MusicSoundSection, AromaScentSection } from '../components/blueprint/BlueprintSensory';
import { SponsorsSection, OntarioTourismSection, GurdwarasSection, PreviousSponsorsSection, SchoolsSection, WeddingPlannersSection, ResortSalesSection, InvestorsSection } from '../components/blueprint/BlueprintPartners';
import { DownloadsSection, FinalCTASection } from '../components/blueprint/BlueprintResources';
import { TeamSection, teamIcons, GeneralInfoDivider, ProductionTeamsDivider, AThinkStudioContent, HistoryTeamContent, PRMarketingTeamContent, FinanceTeamContent } from '../components/blueprint/BlueprintTeams';
export function BlueprintPage() {
  useEffect(() => {
    document.body.classList.add('bg-[#0a0a0f]', 'text-white', 'overflow-x-hidden');
    return () => {
      document.body.classList.remove('bg-[#0a0a0f]', 'text-white', 'overflow-x-hidden');
    };
  }, []);
  return <LanguageProvider data-id="element-3567">
      <div className="relative bg-[#0a0a0f] min-h-screen" data-id="element-3568">
        <Navbar data-id="element-3569" />
        <BlueprintNav data-id="element-3570" />

        <main className="w-full xl:pl-56" data-id="element-3571">
          <BlueprintHero data-id="element-3572" />

          {/* ─── GENERAL INFORMATION ─── */}
          <GeneralInfoDivider data-id="element-3573" />
          <OverviewSection data-id="element-3574" />
          <GuestJourneySection data-id="element-3575" />
          <StoryArcSection data-id="element-3576" />

          {/* ─── PRODUCTION TEAMS ─── */}
          <ProductionTeamsDivider data-id="element-3577" />

          <div className="container mx-auto px-6 max-w-5xl" data-id="element-3578">
            <TeamSection teamNumber={1} teamName="Secret Location" lead="Secret Location" role="Creating the immersive environment — portals, projections, floor map, and spatial design" icon={teamIcons.secretLocation} defaultExpanded={true} data-id="element-3579">
              <FivePortalsSection data-id="element-3580" />
              <FloorMapSection data-id="element-3581" />
              <FinalRevealSection data-id="element-3582" />
              <MusicSoundSection data-id="element-3583" />
            </TeamSection>

            <TeamSection teamNumber={2} teamName="AThink Studio" lead="AThink Studio (with Seadance)" role="Generative AI visuals and acting videos in Punjabi and English" icon={teamIcons.athinkStudio} data-id="element-3584">
              <AThinkStudioContent data-id="element-3585" />
            </TeamSection>

            <TeamSection teamNumber={3} teamName="Scent & Drink Team" lead="Mystical Mocktails" role="Designing the aromatic journey and drink pairings for each portal" icon={teamIcons.scentDrink} data-id="element-3586">
              <AromaScentSection data-id="element-3587" />
              <div className="p-8 md:p-10 border-t border-[#d4a017]/10" data-id="element-3588">
                <h3 className="font-serif text-2xl text-[#f5f0e8] mb-4" data-id="element-3589">
                  Drink Pairings
                </h3>
                <p className="text-[#f5f0e8]/50 font-light leading-relaxed mb-6" data-id="element-3590">
                  Working closely with the Food Team, Mystical Mocktails designs
                  bespoke non-alcoholic pairings that match the aromatic profile
                  of each portal.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3591">
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3592">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3593">
                      Akali Phula Singh
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3594">
                      Saffron lassi with black pepper
                    </p>
                  </div>
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3595">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3596">
                      Lehna Singh Majithia
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3597">
                      Cardamom cold brew
                    </p>
                  </div>
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3598">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3599">
                      Hari Singh Nalwa
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3600">
                      Kashmiri kahwa
                    </p>
                  </div>
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3601">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3602">
                      Fakir Azizuddin
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3603">
                      Rose sherbet with edible gold
                    </p>
                  </div>
                  <div className="border border-[#d4a017]/10 bg-[#0f0f23]/30 p-4" data-id="element-3604">
                    <p className="text-[#d4a017]/70 text-sm font-medium mb-1" data-id="element-3605">
                      Maharani Jind Kaur
                    </p>
                    <p className="text-[#f5f0e8]/40 text-sm font-light italic" data-id="element-3606">
                      Masala chai with honey
                    </p>
                  </div>
                </div>
              </div>
            </TeamSection>

            <TeamSection teamNumber={4} teamName="Food Team" lead="TBD" role="Food design, preparation, and synchronized serving during the experience" icon={teamIcons.food} data-id="element-3607">
              <FoodDrinkSection data-id="element-3608" />
            </TeamSection>

            <TeamSection teamNumber={5} teamName="Sales Team" lead="TBD" role="Promotion, partnerships, and driving ticket sales across all channels" icon={teamIcons.sales} data-id="element-3609">
              <SponsorsSection data-id="element-3610" />
              <OntarioTourismSection data-id="element-3611" />
              <GurdwarasSection data-id="element-3612" />
              <PreviousSponsorsSection data-id="element-3613" />
              <SchoolsSection data-id="element-3614" />
              <WeddingPlannersSection data-id="element-3615" />
              <ResortSalesSection data-id="element-3616" />
              <InvestorsSection data-id="element-3617" />
            </TeamSection>

            <TeamSection teamNumber={6} teamName="History Team" lead="Ajaypal" role="Ensuring historical accuracy across all content, visuals, and narrative" icon={teamIcons.history} data-id="element-3618">
              <HistoryTeamContent data-id="element-3619" />
            </TeamSection>

            <TeamSection teamNumber={7} teamName="PR & Marketing Team" lead="TBD" role="Public relations, media outreach, and marketing to drive attendance" icon={teamIcons.prMarketing} data-id="element-3620">
              <PRMarketingTeamContent data-id="element-3621" />
            </TeamSection>

            <TeamSection teamNumber={8} teamName="Finance Team" lead="TBD" role="Budget management, revenue projections, and ensuring commercial viability" icon={teamIcons.finance} data-id="element-3622">
              <FinanceTeamContent data-id="element-3623" />
            </TeamSection>
          </div>

          {/* ─── RESOURCES ─── */}
          <DownloadsSection data-id="element-3624" />
          <FinalCTASection data-id="element-3625" />
        </main>

        <div className="xl:pl-56" data-id="element-3626">
          <Footer data-id="element-3627" />
        </div>
      </div>
    </LanguageProvider>;
}